import { noop } from 'lodash-es';
import { createContext } from 'react';
export const RadioGroupContext = createContext({
    isDefault: true,
    registerValue: noop,
    destroyValue: noop,
    getChecked: () => false,
    changeChecked: noop
});
